<template>
  <g id="Крестик_закрытия_попапа" data-name="Крестик закрытия попапа" transform="translate(-1805.086 -53.086)">
    <line
      id="Line_179"
      data-name="Line 179"
      x2="26.116"
      y2="26.116"
      transform="translate(1806.5 54.5)"
      fill="none"
      stroke="#707070"
      stroke-linecap="round"
      stroke-width="2" />
    <line
      id="Line_180"
      data-name="Line 180"
      x1="26.116"
      y2="26.116"
      transform="translate(1806.5 54.5)"
      fill="none"
      stroke="#707070"
      stroke-linecap="round"
      stroke-width="2" />
  </g>
</template>
